import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';

import {
    ThemeProvider,
} from "@mui/material";

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { ScaleAndDrag, darkTheme } from "@/components/Editor";

import { Frame } from "@/components/frames";
import './Editor.css';
import {sendOverlayData, fetchOverlayData, fetchOverlayDataUser} from "@/utils/backendUtils";
import {useEffect, useRef, useState} from "react";
import eventBus from "@/utils/globalPubSub";
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const BoardBox = styled(Box)(({ theme }) => ({
    flex: 1,
    position: 'relative'
}));

// const MAIN_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2IiwiYXV0aCI6dHJ1ZSwiaWF0IjoxNjQ5Nzc4NjYxLCJleHAiOjE2NTIzNzA2NjF9.I4f1KtFOu41gU7EcWUgUTTjCwFp2R-X2MwurwIutyi8'
// const MAIN_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjMwMDgwLCJhdXRoIjp0cnVlLCJpYXQiOjE2NTA1NTg4NzF9.t3QH8bmdwnMJMexOKFs71SD9oMoAOWS_fzJEpBsv1rA'
const MAIN_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2IiwiYXV0aCI6dHJ1ZSwiaWF0IjoxNjQ5Nzc4NjYxLCJleHAiOjE2NTIzNzA2NjF9.I4f1KtFOu41gU7EcWUgUTTjCwFp2R-X2MwurwIutyi8'
export default function Editor() {
    let { userId } = useParams();
    const [widgets, setWidgets] = React.useState([]);
    const [token, setToken] = useState(window.token);

    useEffect(async () => {
        eventBus.on("callbackNativeSupportReady", () => {
            window?.getUserInfo?.();
        });
        eventBus.on("callbackUserInfo", (userInfo) => {
            setToken(userInfo.token)
        });

        return () => {
            eventBus.remove("callbackNativeSupportReady");
            eventBus.remove("callbackUserInfo");
        }
    }, [])

    useEffect(async () => {
        if (token) {
            try {
                const result = await fetchOverlayData(token);
                if (result.success) {
                    try {
                        setWidgets(result.data?.data ? JSON.parse(JSON.parse(result.data?.data)) : [])
                    } catch (e) {
                        setWidgets(result.data?.data ? JSON.parse(result.data?.data) : []);
                    }
                } else {
                    // alert(result.message)
                }
            } catch (e) {
                // alert(e);
            }

        }
    }, [token]);

    useEffect(async () => {
        if (userId) {
            try {
                console.log('result')
                const result = await fetchOverlayDataUser(userId);
                console.log(result)
                if (result.success) {
                    // console.log(JSON.parse(JSON.parse(result.data?.data)))
                    try {
                        setWidgets(result.data?.data ? JSON.parse(JSON.parse(result.data?.data)) : [])
                    } catch (e) {
                        setWidgets(result.data?.data ? JSON.parse(result.data?.data) : []);
                    }
                } else {
                    // alert(result.message)
                }
            } catch (e) {
                // alert(e);
                console.log(e)
            }

        }
    }, []);
    
    return (
        <React.Fragment>
            <ThemeProvider theme={darkTheme}>
                <Box display={"flex"} flexDirection={"column"} height={"100%"}>
                    <CssBaseline />

                    <BoardBox>
                        {
                            widgets.map((it) => (
                                <Box
                                    position={'absolute'}
                                    left={it?.css?.x ? it?.css?.x : 0}
                                    top={it?.css?.y ? it?.css?.y : 0}
                                    sx={{
                                        transform: `scale(${it?.css?.scale ? it?.css?.scale : 1})`,
                                        transformOrigin: '0 0'
                                    }}
                                >
                                    {(it.type !== 'iframe' && it.type !== 'image') && <Frame config={it}/>}
                                    {it.type === 'iframe' && <Box style={{ height: '100%', cursor:'pointer'}}>
                                        <iframe
                                            style={{
                                                border: '0',
                                                margin: '0',
                                                overflow: 'hidden',
                                                padding: 0,
                                                width: '1920px',
                                                height: '1080px'
                                            }}
                                            src={it.form[0]?.value ?? ''}
                                        />
                                    </Box>}
                                    {it.type === 'image' && <Box style={{ height: '100%', cursor:'pointer'}}>
                                        <img
                                            style={{
                                                border: '0',
                                                margin: '0',
                                                overflow: 'hidden',
                                                padding: 0,
                                                width: it.css.width ? it.css.width : '192px',
                                                height: it.css.height ? it.css.height : '108px'
                                            }}
                                            src={it.form[0]?.value ?? ''}
                                        />
                                    </Box>}
                                </Box>
                            ))
                        }
                    </BoardBox>
                </Box>
            </ThemeProvider>
        </React.Fragment>
    );
}